







































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { TanksApi, Tank, Sensor, EntityLocation } from '@/api';
import TransceiverSuggest from '@/components/form pickers/transceiverSuggest.vue';
import SensorSuggest from '@/components/form pickers/sensorSuggest.vue';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import Toast from '@/components/display/toast.vue';
import routerLinkButton from '@/components/elements/buttons/router-link-button.vue';
import LocationInput from '@/components/form pickers/LocationInput.vue';
import { EntityLocationService } from '@/services/entity-location-service';
import { Constants } from '@/common/Constants';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

@Component({
	components: {
		SaveCancelButtons,
		routerLinkButton,
		TransceiverSuggest,
		SensorSuggest,
		secondaryNav,
		Toast,
		LocationInput,
	},
	validations: {
		tank: {
			transceiver: { required },
			sensor: { required },
		},
	},
	mixins: [validationMixin],
})
export default class InstallTankModal extends Vue {
	@Prop(Object)
	public tank!: Tank & { entitylocation: EntityLocation };

	@Prop(String)
	public modalType!: string;

	@Prop(Boolean)
	public tankChimeraSwitchEnabled?: boolean;

	@Prop({ type: Boolean, default: false })
	public useChimeras: boolean;

	public transceiverId: number = 0;
	public sensor: Sensor | null = null;

	public loading = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;

	private toast: Toast = new Toast();

	public cancel() {
		this.$bvModal.hide(`${this.modalType}Modal${this.tank.id}`);
		this.$emit('loadTank');
	}

	public async updateTank() {
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		let data = {
			transceiverId: this.tank.transceiver.id,
			sensorId: this.tank.sensor.id,
			entityType: 'tanks',
		};

		try {
			await new TanksApi().installTank(this.tank.id, { data });
		} catch (e) {
			let error;
			if (e.response) {
				error = 'Error Saving Tank ' + JSON.stringify(e.response.data.errors, null, 2);
			} else if (e.request) {
				error = 'Error Saving Tank, network Error';
			} else {
				error = 'Error Saving Tank';
			}
			this.toast.makeToast(error, 'Error Installing Tank', 'danger', false);
			this.submitStatus = 'ERROR';
			return;
		}
		this.toast.makeToast('Successfully Installed Tank', 'Successful', 'success', false);
		this.cancel();
		this.$emit('loadTank');
		this.submitStatus = 'OK';
	}
}
